<template>
	<div class="block-notify-container" v-if="$slots.default">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'BlockContainer'
};
</script>

<style lang="scss" scoped>
.block-notify-container {
	margin-bottom: $gutter-xl;
}
</style>
